"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolStatusToJSON = exports.CommunityPoolStatusFromJSONTyped = exports.CommunityPoolStatusFromJSON = exports.CommunityPoolStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var CommunityPoolStatus;
(function (CommunityPoolStatus) {
    CommunityPoolStatus["INVITED"] = "INVITED";
    CommunityPoolStatus["JOINED"] = "JOINED";
    CommunityPoolStatus["REVOKED"] = "REVOKED";
})(CommunityPoolStatus = exports.CommunityPoolStatus || (exports.CommunityPoolStatus = {}));
function CommunityPoolStatusFromJSON(json) {
    return CommunityPoolStatusFromJSONTyped(json, false);
}
exports.CommunityPoolStatusFromJSON = CommunityPoolStatusFromJSON;
function CommunityPoolStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CommunityPoolStatusFromJSONTyped = CommunityPoolStatusFromJSONTyped;
function CommunityPoolStatusToJSON(value) {
    return value;
}
exports.CommunityPoolStatusToJSON = CommunityPoolStatusToJSON;
